import React from 'react';

import './index.css';

type BackdropProps = {
    onClick?: () => void;
}

function Backdrop({ onClick }: BackdropProps) {
    return <div className='backdrop' onClick={onClick} />
}

export default Backdrop;